// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3lsyM","title":"ClientReferral_title__1Y38p","itemText":"ClientReferral_itemText__3N_rm"};